import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  CivilityComponent,
  ContactInformationComponent,
  GenderComponent,
  HelloUserComponent,
  InlineProfileDataComponent,
  ItemProfileDisplayComponent,
  ProfileDataComponent,
  UiProfileDisplayComponent,
  UserLogoComponent,
  UserLogoData,
  UsersListComponent,
} from '@camelot/ui';
import { CamIconType } from '@camelot/icons';
import { Civility } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CivilityComponent,
        ContactInformationComponent,
        GenderComponent,
        HelloUserComponent,
        InlineProfileDataComponent,
        ItemProfileDisplayComponent,
        ProfileDataComponent,
        TestIdDirective,
        UiProfileDisplayComponent,
        UserLogoComponent,
        UsersListComponent,
    ],
    template: `
    <cam-user-logo camTestId="cam-user-logo" />
    <cam-users-list camTestId="cam-users-list" [users]="this.users$" />
    <cam-profile-data camTestId="cam-profile-data" [profile]="this.profile" />
    <cam-inline-profile-data camTestId="cam-inline-profile-data" [profile]="this.profile" />
    <cam-ui-profile-display camTestId="cam-ui-profile-display" label="Jane Doe" />
    <cam-item-display camTestId="cam-item-display" label="An item" />
    <cam-hello-user camTestId="cam-hello-user" title="Hello" />
    <cam-civility camTestId="cam-civility" [civility]="this.civility" />
    <cam-gender camTestId="cam-gender" [gender]="1" />
    <cam-contact-information
      camTestId="cam-contact-information"
      value="jane@example.com"
      icon="email"
      [localIcon]="this.localIcon"
    />
  `
})
export class UiPeopleCase {
  public civility = Civility.Sir;
  public localIcon = CamIconType.Add;
  public profile = { email: 'jane@example.com', phoneNumber: '+3210000000', title: { main: 'Jane Doe' } };
  public users$ = of<UserLogoData[]>([{ firstName: 'Jane', lastName: 'Doe' }]);
}
